import styled from 'styled-components';

const NumberList = styled.ol`
  list-style-type: decimal;
  padding-left: 1.5rem;
`;

export default NumberList;
